import { Routes } from "@angular/router";

const show404Error = () =>
    import("#pages/error-404/error-404.routes").then((m) => m.ERROR_404_ROUTES);

const promoRoutes = [
    {
        path: "promos",
        loadChildren: () => import("#pages/promos/promos.routes").then((m) => m.PROMOS_ROUTES),
    },
    {
        path: "promo/create",
        loadChildren: () =>
            import("#pages/create-promo/create-promo.routes").then((m) => m.CREATE_PROMOS_ROUTES),
    },
    {
        path: "promo/edit/:id",
        loadChildren: () =>
            import("#pages/edit-promo/edit-promo.routes").then((m) => m.PROMOS_ROUTES),
    },
    {
        path: "promo/clone/:id",
        loadChildren: () =>
            import("#pages/clone-promo/clone-promo.routes").then((m) => m.PROMOS_ROUTES),
    },
    {
        path: "promo/:id",
        loadChildren: () => import("#pages/promo/promo.routes").then((m) => m.PROMOS_ROUTES),
    },
];

const promoCodeRoutes = [
    {
        path: "promo-codes",
        loadChildren: () =>
            import("#pages/promo-codes/promo-codes.routes").then((m) => m.PROMO_CODES_ROUTES),
    },
    {
        path: "promo-code/create",
        loadChildren: () =>
            import("#pages/create-promo-code/create-promo-code.routes").then(
                (m) => m.CREATE_PROMO_CODE_ROUTES
            ),
    },
    {
        path: "promo-code/edit/:id",
        loadChildren: () =>
            import("#pages/edit-promo-code/edit-promo-code.routes").then(
                (m) => m.EDIT_PROMO_CODE_ROUTES
            ),
    },
    {
        path: "promo-code/clone/:id",
        loadChildren: () =>
            import("#pages/clone-promo-code/clone-promo-code.routes").then(
                (m) => m.CLONE_PROMO_CODE_ROUTES
            ),
    },
    {
        path: "promo-code/:id",
        loadChildren: () =>
            import("#pages/promo-code/promo-code.routes").then((m) => m.PROMO_CODE_ROUTES),
    },
];

const configRoutes = [
    {
        path: "config",
        loadChildren: () => import("#pages/config/config.routes").then((m) => m.CONFIG_ROUTE),
    },
];

const cliRoutes = [
    {
        path: "cli-commands",
        loadChildren: () => import("#pages/cli-commands/cli-commands.routes").then((m) => m.ROUTES),
    },
];

const promoPrioritiesRoutes = [
    {
        path: "promo-priorities",
        loadChildren: () =>
            import("#pages/promo-priorities/promo-priorities.routes").then(
                (m) => m.PROMO_PRIORITIES_ROUTES
            ),
    },
];

export const routes: Routes = [
    ...promoRoutes,
    ...promoCodeRoutes,
    ...configRoutes,
    ...cliRoutes,
    ...promoPrioritiesRoutes,
    {
        path: "",
        redirectTo: "/promos",
        pathMatch: "full",
    },
    { path: "**", pathMatch: "full", loadChildren: show404Error },
];
